import React, { useRef, useState, useLayoutEffect } from 'react'
import styled from 'styled-components'

import { Box } from 'components'
import StepperProgress from './StepperProgress'

interface Step {
  title: string
}

interface StepperProps {
  steps: Step[]
  step: number
  width?: string | number
  height?: string | number
  onStepChange?: (currentStep: number, stepIndex: number, steps: Step[], isLast: boolean, isFirst: boolean) => void
  animate?: boolean
}

export interface StepProps {
  currentStep: number
  isLast: boolean
  isFirst: boolean
  step: number
}

const Stepper: React.FC<StepperProps> = ({ steps, step, onStepChange, width = 800, animate = false, height = 500 }) => {
  const [currentStep, setCurrentStep] = useState<number>(step || 1)
  const stepperSelector = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const moveStepper = () => {
      if (stepperSelector.current) {
        const stepper = stepperSelector.current
        const stepWidth = stepper.offsetWidth / steps.length
        stepper.style.transform = `translateX(-${stepWidth * (currentStep - 1)}px)`
      }
    }
    moveStepper()
    setCurrentStep(step)
    onStepChange?.(currentStep, currentStep - 1, steps, currentStep === steps.length, currentStep === 1)
  }, [currentStep, step, steps, setCurrentStep, onStepChange])

  return (
    <StepperWrapper width={width} height={height} className="stepper stepper-wrapper">
      <StepperProgress stepTitles={steps.map((step) => step.title)} currentStep={currentStep} animate={animate} />
    </StepperWrapper>
  )
}

export default Stepper

const StepperWrapper = styled(Box)`
  position: relative;
  overflow: hidden;
  display: inline-block;
`
